import { render } from "./Directive.vue?vue&type=template&id=4d96c256&scoped=true"
import script from "./Directive.vue?vue&type=script&lang=ts"
export * from "./Directive.vue?vue&type=script&lang=ts"

import "./Directive.vue?vue&type=style&index=0&id=4d96c256&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4d96c256"

export default script